export { default } from './footer-banner';
